import { CSSProperties } from "react";

export const parseStringToCssProperties = (styleString: string): CSSProperties => {
  if (!styleString) return {};
  const styleProps: Record<string, string> = {};
  const declarations = styleString.split(';').filter(Boolean);
  for (const declaration of declarations) {
    const [property, value] = declaration.split(':').map(part => part.trim());
    if (!property || !value) return {};
    const propName = property.replaceAll(/-([a-z])/g, (_, letter) => letter.toUpperCase());
    styleProps[propName] = value;
  }
  try {
    const sxProps = styleProps as CSSProperties
    return sxProps;
  } catch {
    console.warn('parseStringToCssProperties: fail to cast as SxProps: %o', styleProps);
    return {};
  }
}
